import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/index.vue' /* 首页 */
import Mine from '../pages/mine/index.vue' /* 我的 */
import Video from '../pages/video/index.vue' /* 视频 */
import Login from '../pages/login/index.vue' /* 登录 */
import Register from '../pages/login/register.vue' /* 注册 */
import Recharge from '../pages/mine/Recharge.vue' /* 充值 */
import Withdraw from '../pages/mine/Withdraw' /* 提现 */
import WithdrawRecord from '../pages/mine/WithdrawRecord' /* 提现记录 */
import Infomation from '../pages/mine/Infomation.vue' /* 基本信息 */
import vip from '../pages/mine/vip.vue' /* vip */
import Setting from '../pages/mine/Setting.vue' /* 设置 */
import Personalreport from '../pages/mine/Personalreport' /* 个人表报 */
import GameRecord from '../pages/mine/GameRecord' /* 投票记录 */
import Notice from '../pages/mine/Notice.vue' /* 公告 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue' /* 客服列表 */
import PlayVideo from '../pages/video/PlayVideo' /* 视频播放页面 */
import Setbank from '../pages/mine/Setbank' /* 银行卡 */
import BindCard from '../pages/mine/BindCard' /* 绑定银行卡界面 */
import Setname from '../pages/mine/Setname.vue' /* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue' /* 修改性别 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue' /* 修改登录密码 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue' /* 修改资金密码 */
import Language from '../pages/mine/Language.vue' /* 语言选择 */
import Choose from '../pages/choose/index.vue' /* 投票 */
import Chooses from '../pages/choose/choose.vue' /* 投票详情 */
import Details from '../pages/lottery/details' /* 地区选妃 */
import Lottery from '../pages/lottery/index.vue' /* 选择地区 */
import concubineDetails from '../pages/lottery/concubineDetails.vue' /* 选妃详情 */

import depositRecords from '../pages/depositRecords/index.vue' /* 存款记录 */
import moneylog from '../pages/moneylog/index.vue' /* 细节 */


Vue.use(VueRouter)
const routes = [{
		path: '/',
		redirect: '/login',
		component: Login,
	},
	{
		path: '/Home',
		name: 'home',
		component: Home,

	},
	{
		path: '/Choose',
		name: 'choose',
		component: Choose,

	},

	{
		path: '/Mine',
		name: 'mine',
		component: Mine,

	},
	{
		path: '/Video',
		name: 'video',
		component: Video,

	},
	{
		path: '/Login',
		name: 'login',
		component: Login,

	},
	{
		path: '/Register',
		name: 'register',
		component: Register,

	},
	{
		path: '/ServiceOnline',
		name: 'ServiceOnline',
		component: ServiceOnline,

	},
	{
		path: '/concubineDetails',
		name: 'concubineDetails',
		component: concubineDetails,

	},
	{
		path: '/Setting',
		name: 'Setting',
		component: Setting,

	},
	{
		path: '/Infomation',
		name: 'Infomation',
		component: Infomation,
	},
	{
		path: '/vip',
		name: 'vip',
		component: vip,
	},
	{
		path: '/Setname',
		name: 'Setname',
		component: Setname,

	},
	{
		path: '/Setsex',
		name: 'Setsex',
		component: Setsex,

	},
	{
		path: '/Language',
		name: 'Language',
		component: Language,

	},
	{
		path: '/Recharge',
		name: 'Recharge',
		component: Recharge,

	},
	{
		path: '/SetPayPassword',
		name: 'SetPayPassword',
		component: SetPayPassword,

	},
	{
		path: '/SetLoginPassword',
		name: 'SetLoginPassword',
		component: SetLoginPassword,

	},
	{
		path: '/Lottery',
		name: 'Lottery',
		component: Lottery,

	},
	{
		path: '/Chooses',
		name: 'Chooses',
		component: Chooses,

	},
	{
		path: '/Notice',
		name: 'Notice',
		component: Notice,

	},
	{
		path: '/PlayVideo',
		name: 'PlayVideo',
		component: PlayVideo,

	},
	{
		path: '/Setbank',
		name: 'Setbank',
		component: Setbank,

	},
	{
		path: '/BindCard',
		name: 'BindCard',
		component: BindCard,

	},
	{
		path: '/Withdraw',
		name: 'Withdraw',
		component: Withdraw,

	},
	{
		path: '/Personalreport',
		name: 'Personalreport',
		component: Personalreport,

	},
	{
		path: '/WithdrawRecord',
		name: 'WithdrawRecord',
		component: WithdrawRecord,

	},
	{
		path: '/GameRecord',
		name: 'GameRecord',
		component: GameRecord,

	},
	{
		path: '/detail',
		name: 'Details',
		component: Details
	},

	{
		path: '/records',
		name: 'depositRecords',
		component: depositRecords
	},
	{
		path: '/moneylog',
		name: 'moneylog',
		component: moneylog
	}
];

//生成路由实例
const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => { //修改标题路由配置加上这个
	//document.title = to.matched[0].meta.title
	document.title = 'True Meet'
	next()
})

export default router